import * as Api from './api';
import * as actionTypes from './actionTypes';
import * as eventTypes from './eventTypes';
import { OFFER_PARTNER_KNOCKOUT_CRITERIA_UPDATED } from 'features/offer/edit/client/knockoutCriteria/eventTypes';
import { sendHttpRequest, sendHttpCommandAndWaitForEvent } from 'actions/actionCreators/httpActions';
import { showError } from 'actions/actionCreators/snackbarActions';

export function loadDocumentScoringResult(documentId, siteId) {
  return async (dispatch, getState) => {
    const key = `${documentId}-${siteId}`;
    let loading = false,
      loaded = false;
    const scoring = getState().document.scoringData[key];
    if (scoring && scoring.scoringResult) {
      loading = scoring.scoringResult.loading;
      loaded = scoring.scoringResult.loaded;
    }

    if (loading || loaded) return;

    dispatch({ type: actionTypes.LOAD_DOCUMENT_SCORING_RESULT_STARTED, id: key });
    try {
      const scoringResult = await dispatch(sendHttpRequest(Api.getDocumentScoringResult(documentId, siteId)));
      dispatch({ type: actionTypes.LOAD_DOCUMENT_SCORING_RESULT_SUCCESS, payload: scoringResult, id: key });
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function loadDocumentScoringGrids(documentId, siteId) {
  return async (dispatch, getState) => {
    const key = `${documentId}-${siteId}`;
    let loading = false,
      loaded = false;
    let scoring = getState().document.scoringData[key];

    if (scoring && scoring.scoringGrids) {
      loading = scoring.scoringGrids.loading;
      loaded = scoring.scoringGrids.loaded;
    }

    if (loading || loaded) return;

    dispatch({ type: actionTypes.LOAD_DOCUMENT_SCORING_GRIDS_STARTED, id: key });
    try {
      const scoringGrids = await dispatch(sendHttpRequest(Api.getScoringGrids(documentId, siteId)));
      dispatch({ type: actionTypes.LOAD_DOCUMENT_SCORING_GRIDS_SUCCESS, payload: scoringGrids, id: key });
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function updateDocumentScoringKnockoutCriteria(documentId, siteId, documentScoringGridId, knockoutCriteria, fromPartner, partnerId) {
  return async dispatch => {
    try {
      const event = await dispatch(
        sendHttpCommandAndWaitForEvent(
          Api.updateScoringKnockoutCriteria(documentId, siteId, documentScoringGridId, knockoutCriteria, fromPartner, partnerId),
          'UpdateDocumentScoringKnockoutCriteriaInProgress',
          [eventTypes.DOCUMENT_SCORING_KNOCKOUT_CRITERIA_UPDATED, OFFER_PARTNER_KNOCKOUT_CRITERIA_UPDATED]
        )
      );

      return event;
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function updateDocumentScoringFinancialIndicators(
  documentId,
  siteId,
  documentScoringGridId,
  entityType,
  engineScoringId,
  scoringClassificationId,
  indicatorList,
  periodList
) {
  return async dispatch => {
    try {
      const event = await dispatch(
        sendHttpCommandAndWaitForEvent(
          Api.updateScoringFinancialIndicators(
            documentId,
            siteId,
            documentScoringGridId,
            entityType,
            engineScoringId,
            scoringClassificationId,
            indicatorList,
            periodList
          ),
          'UpdateDocumentScoringFinancialIndicatorsInProgress',
          [eventTypes.DOCUMENT_SCORING_FINANCIAL_INDICATORS_UPDATED]
        )
      );

      return event;
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function updateFinancialIndicatorDimensions(
  documentId,
  siteId,
  documentScoringGridId,
  entityType,
  scoringClassificationId,
  indicatorList,
  periodList,
  engineScoringId
) {
  return async dispatch => {
    try {
      const event = await dispatch(
        sendHttpCommandAndWaitForEvent(
          Api.updateFinancialIndicatorDimensions(
            documentId,
            siteId,
            documentScoringGridId,
            entityType,
            scoringClassificationId,
            indicatorList,
            periodList,
            engineScoringId
          ),
          'UpdateFinancialIndicatorDimensionsInProgress',
          [eventTypes.DOCUMENT_FINANCIAL_INDICATOR_DIMENSIONS_UPDATED]
        )
      );

      return event;
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function updateDocumentScoringCategory(
  documentId,
  siteId,
  documentScoringGridId,
  scoringClassificationId,
  entityType,
  scoringCategories
) {
  return async dispatch => {
    try {
      const event = await dispatch(
        sendHttpCommandAndWaitForEvent(
          Api.updateScoringCategory(documentId, siteId, documentScoringGridId, scoringClassificationId, entityType, scoringCategories),
          'UpdateDocumentScoringCategoryInProgress',
          [eventTypes.DOCUMENT_SCORING_CATEGORY_UPDATED]
        )
      );

      return event;
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function generateScoring(documentId, siteId) {
  return async dispatch => {
    try {
      const event = await dispatch(
        sendHttpCommandAndWaitForEvent(Api.generateScoring(documentId, siteId), 'GeneratingScoringInProgress', [
          eventTypes.DOCUMENT_SCORING_INVALIDATED
        ])
      );

      return event;
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}


export function updateScoringFileWithAccountStatementDataInProgress(
  documentId,
  siteId
) {
  return async dispatch => {
    try {
      const event = await dispatch(
        sendHttpCommandAndWaitForEvent(
          Api.updateScoringFileWithAccountStatementData(
            documentId,
            siteId,
            2
          ),
          'UpdateScoringFileWithAccountStatementDataInProgress',
          [eventTypes.DOCUMENT_SCORING_INVALIDATED]
        )
      );

      return event;
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}